namespace Dashboard {

    class DashboardBreadcrumb {
        private crumbs;
        private bookingId;
        private pages;
        constructor(
            private dashboardBreadCrumbDetails,
            private dashboardBookingService,
            private $routeParams) {
            this.bookingId = parseInt(this.$routeParams.bookingId, 10);
            this.dashboardBookingService.getBookingInfo(this.bookingId).then((booking) => {
                this.crumbs = this.dashboardBreadCrumbDetails.get(this.pages, booking);
            });
        }
    }

    angular
    .module('dashboard')
    .directive('dashboardBreadcrumb', (): ng.IDirective => {

        return {
            restrict: 'E',
            bindToController: {
                pages: '@'
            },
            controller: DashboardBreadcrumb,
            controllerAs: 'dbc',
            replace: true,
            templateUrl: 'partials/home/directivetemplate?type=DashboardBreadcrumb'
        };

    });
}

